import {
  getScheduleAvailablePaymentMethods,
  putPayment,
} from '../api/bernabeu';

import {
  paymentSlice,
  callTypes
} from "../../redux/reducers/paymentSlice";

const { actions } = paymentSlice;

const fetchScheduleAvailablePaymentMethods = (branchId) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getScheduleAvailablePaymentMethods(branchId).then((response: any) => {
      resolve(response.data);

      dispatch(actions.paymentFetched());
    }).catch((error) => {
      console.log('fetchScheduleAvailablePaymentMethods falhou:');
      console.log({error});

      dispatch(actions.paymentFetched());

      reject(false);
    });
  });
}

const fetchUpdatePaymentMethod = (id: any, paymentMethod: any, clientCardId = '') => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    let params: any = {
      payment_method: paymentMethod,
    };

    if (clientCardId) {
      params.client_card_id = clientCardId;
    }

    putPayment(id, params).then(response => {
      dispatch(actions.paymentFetched());

      resolve(response);
    }).catch((error) => {
      console.log('fetchUpdatePaymentMethod falhou:');
      console.log({error});

      dispatch(actions.paymentFetched());

      reject(false);
    });
  });
}

export {
  fetchScheduleAvailablePaymentMethods,
  fetchUpdatePaymentMethod,
}